import { labelList } from './text.js';
/**
 * The talent's activity log in words (spec 1.8, 2.3; GET /portal/me/activity), PURE and shared: each entry as one
 * sentence, from its kind, its agency and the labels it names (never a value).
 */
/** One entry as a sentence. */
export function activityLine(i) {
    const agency = i.agency || 'An agency';
    const labels = i.labels.length ? i.labels : Array.isArray(i.detail.labels) ? i.detail.labels.filter((l) => typeof l === 'string') : [];
    const what = labelList(labels, 3, 'details');
    switch (i.kind) {
        case 'consent.intake':
            return `You shared ${what} with ${agency} on a form`;
        case 'grant.added':
            return `You shared ${what} with ${agency}`;
        case 'grant.ended':
            return i.detail.reason === 'revoked' ? `You stopped sharing ${what} with ${agency}` : `${agency} stopped getting updates to ${what}`;
        case 'ask.created':
            return `${agency} asked for ${what}`;
        case 'ask.declined':
            return `You said no to ${agency} about ${what}`;
        case 'answers.updated':
            return `You updated ${what}`;
        case 'answers.confirmed':
            return `You confirmed ${what}`;
        case 'suggestion.accepted':
            return `You accepted a change from ${agency} to ${what}`;
        case 'suggestion.kept':
            return `You kept your answer for ${what}. ${agency} keeps its own.`;
        case 'agency.left':
            return `You left ${agency}`;
        case 'record.linked':
            return `${agency} was linked to this profile`;
        case 'record.merged':
            return 'Two profiles became this one';
        case 'record.unmerged':
            return 'A merge was undone';
        case 'guardian_shared.reviewed':
            return 'You checked what was shared for you';
        default:
            return 'Your profile changed';
    }
}
//# sourceMappingURL=activity.js.map